const numbers = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10 };
export function normalizeSpeech(text) { return String(text).toLowerCase().replace(/[.,!?;:]/g, ' ').replace(/\s+/g, ' ').trim(); }
export function parseVoiceCommand(transcript, prefix = 'tutor') {
  const text = normalizeSpeech(transcript);
  const wake = normalizeSpeech(prefix);
  if (!wake || !text.startsWith(`${wake} `)) return null;
  const command = text.slice(wake.length + 1).trim();
  const exact = {
    play: 'play', resume: 'play', pause: 'pause', stop: 'pause', replay: 'replay',
    'from start': 'restart', 'replay from start': 'restart', 'play from start': 'restart', restart: 'restart',
    'loop start': 'loop-a', 'loop end': 'loop-b', 'loop off': 'loop-off', 'loop on': 'loop-on',
    'normal speed': 'normal-speed', 'next bookmark': 'next', 'previous bookmark': 'previous',
  };
  if (exact[command]) return { type: exact[command] };
  if (/^(slower|slow down)$/.test(command)) return { type: 'rate-step', value: -0.1 };
  if (/^(faster|speed up)$/.test(command)) return { type: 'rate-step', value: 0.1 };
  if (/^(back|backward|backwards)( ten| 10)?( seconds)?$/.test(command)) return { type: 'skip', value: -10 };
  if (/^(forward|forwards)( ten| 10)?( seconds)?$/.test(command)) return { type: 'skip', value: 10 };
  const mark = command.match(/^(?:bookmark|mark)(?: (.+))?$/);
  if (mark) return { type: 'bookmark', name: mark[1] || '' };
  const go = command.match(/^go to (?:bookmark )?(.+)$/);
  if (go) return { type: 'go-bookmark', target: String(numbers[go[1]] ?? go[1]) };
  return null;
}
export function findBookmark(bookmarks, target) {
  const normalized = normalizeSpeech(target);
  // Prefer an exact name; stable displayed numbers are the fallback.
  return bookmarks.find(b => normalizeSpeech(b.name) === normalized)
    ?? bookmarks.find(b => String(b.number) === normalized) ?? null;
}
